import api from '@/api/base'

export default {
  put(pin, time) {
    const cmp = time.company._id ? time.company._id : time.company;
    return api().put(`/weekly/${pin}/${cmp}/time`, time);
  },
  confirm(pin, company, times) {
    return api().post(`/weekly/${pin}/${company._id}/time/confirm`, times);
  },
  delete(pin, time) {
    const cmp = time.company._id ? time.company._id : time.company;
    return api().delete(`/weekly/${pin}/${cmp}/time/${time._id}`);
  },
  get(pin, company, employee, tasks, start, end) {

    return api().post(`/weekly/${pin}/${company._id}/time`, {
      employee: employee._id,
      tasks: tasks.map(t => t._id),
      start: start.format("YYYY-MM-DD"),
      end: end.format("YYYY-MM-DD")
    });
  },
  get_addons(pin, company) {
    return api().get(`/weekly/${pin}/${company._id}/addons`);
  },
  get_crafts(pin, company, employee) {
    return api().get(`/weekly/${pin}/${company._id}/${employee._id}/crafts`);
  }
}
